/**
 * These are all runtime dependencies. Any breaking changes
 * will need a migration path first!
 */
const prefix = 'urn';
const namespace = 'sfextslot';
const owner = 'projects-pilet';
const sfblockNamespace = `${prefix}:sfblock:projects`;
const blockNamespace = `${prefix}:block:projects`;
const drawerNamespace = `${prefix}:drawer:${owner}`;
const resourceType = 'project';
const pluginKeys = {
    conversations: 'conversations',
    files: 'files',
    tasks: 'tasks',
    datatables: 'datatables',
};
const tabsExtensionSlots = {
    tabHome: `${prefix}:${namespace}:${owner}:tabs:home`,
    tabConversations: `${prefix}:${namespace}:${owner}:tabs:${pluginKeys.conversations}`,
    tabTasks: `${prefix}:${namespace}:${owner}:tabs:${pluginKeys.tasks}`,
    tabFiles: `${prefix}:${namespace}:${owner}:tabs:${pluginKeys.files}`,
};
const tilesExtensionSlots = {
    tileFiles: `${prefix}:${namespace}:${owner}:home:tiles:${pluginKeys.files}`,
    tileConversations: `${prefix}:${namespace}:${owner}:home:tiles:${pluginKeys.conversations}`,
};
export const projectsExtensionSlots = {
    createClientLinkButton: `${prefix}:${namespace}:${owner}:create-new-client-for-solution`,
    tabs: `${prefix}:${namespace}:${owner}:tabs`,
    homeTiles: `${prefix}:${namespace}:${owner}:home:tiles`,
    homeTilesWithStyleProp: `${prefix}:${namespace}:${owner}:home:tilesWithStyleProp`,
    dashboardBlock: `${sfblockNamespace}:view:dashboard`,
    deletedFilesTab: `${prefix}:${namespace}:${owner}:recently-deleted:files-tab`,
    deletedResources: `${prefix}:${namespace}:${owner}:options:recentlydeleted`,
    fileExportButton: `${prefix}:${namespace}:${owner}:files:context-bar:export-file-button`,
    tabsExtensionSlots,
    tilesExtensionSlots,
    staticAppSlot: `${prefix}:${namespace}:${owner}:staticapp`,
    filesTabBlock: 'urn:sfblock:files:view:list',
    filesTileBlock: 'urn:sfblock:files:view:tile',
    blockWithHeaderAndPanelZone: `${sfblockNamespace}:headerwithpanel`,
    blockWithHeaderAndCustomizableTabsZone: `${sfblockNamespace}:headerwithcustomizabletabs`,
    projectsListViewBlock: `${blockNamespace}:project-list-view`,
    projectsListViewTabEmptyStateBlock: `${blockNamespace}:project-list-view:tab-empty-state`,
    projectsContainerTitleInlineMetaBlock: `${blockNamespace}:title:inline-meta:options-dropdown`,
    recentlyDeletedBlock: `${blockNamespace}:recently-deleted`,
    recentlyDeletedTitleMetadataBlock: `${blockNamespace}:recently-deleted:title:metadata`,
    projectLoaderBlock: `${blockNamespace}:project-loader`,
    projectHeaderTourBlock: `${blockNamespace}:project-header:tour`,
    projectsViewByTagsBlock: `${blockNamespace}:projects-view-by-tags`,
    associatedProjectsDropdownHeader: `${blockNamespace}:associated-projects-dropdown-header`,
    specEditor: `${prefix}:${namespace}:${resourceType}:spec-editor`,
    projectViewErrorStateBlock: `${blockNamespace}:headerwithcustomizabletabs:error-state`,
};
export const projectsOverlays = {
    createProjectDrawer: `${drawerNamespace}:create-project`,
};
//# sourceMappingURL=extensionTypes.js.map